import * as React from "react";
import type { SVGProps } from "react";
const SvgTShirt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#352F28"
      fillRule="evenodd"
      d="M9 2.167c.879 0 1.652-.454 2.098-1.14.192-.296.496-.527.85-.527h1.219c2.3 0 4.166 1.867 4.166 4.167V8a.836.836 0 0 1-.833.833H14v5.834c0 .46-.373.833-.833.833H4.833A.833.833 0 0 1 4 14.667V8.833H1.5A.836.836 0 0 1 .667 8V4.667C.667 2.367 2.533.5 4.833.5h1.22c.353 0 .657.231.85.527A2.5 2.5 0 0 0 9 2.167m-3.334 0h-.833a2.507 2.507 0 0 0-2.5 2.5v2.5H4V5.5c0-.458.375-.833.833-.833.459 0 .834.375.834.833v8.333h6.666V5.5c0-.458.375-.833.834-.833S14 5.042 14 5.5v1.667h1.667v-2.5c0-1.375-1.125-2.5-2.5-2.5h-.833A4.16 4.16 0 0 1 9 3.833a4.16 4.16 0 0 1-3.334-1.666"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTShirt;
